import { z } from 'zod';

import { permissionSchema } from './positions';

export const organizationAccessSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  roles: z.array(z.string()),
  isAdmin: z.boolean(),
  /** All of them for admins, otherwise those of the member's position. */
  permissions: z.array(permissionSchema),
});
export type OrganizationAccess = z.infer<typeof organizationAccessSchema>;

export const viewerSchema = z.object({
  userId: z.number().int(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  isGlobalAdmin: z.boolean(),
  organizations: z.array(organizationAccessSchema),
});
export type Viewer = z.infer<typeof viewerSchema>;

export const sessionStateSchema = z.discriminatedUnion('authenticated', [
  z.object({ authenticated: z.literal(false), csrfToken: z.string() }),
  z.object({ authenticated: z.literal(true), csrfToken: z.string(), viewer: viewerSchema }),
]);
export type SessionState = z.infer<typeof sessionStateSchema>;

export const loginRequestSchema = z.object({
  email: z.email('Введите email').trim().toLowerCase(),
  password: z.string().min(1, 'Введите пароль').max(256),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const initialPasswordRequestSchema = loginRequestSchema.extend({
  newPassword: z.string().min(8, 'Не короче 8 символов').max(256),
});
export type InitialPasswordRequest = z.infer<typeof initialPasswordRequestSchema>;

export const codeChallengeSchema = z.object({
  destination: z.string(),
  expiresIn: z.number().int(),
});
export type CodeChallenge = z.infer<typeof codeChallengeSchema>;

export const loginResultSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('authenticated'), session: sessionStateSchema }),
  z.object({ status: z.literal('code_required'), challenge: codeChallengeSchema }),
  z.object({ status: z.literal('password_change_required') }),
]);
export type LoginResult = z.infer<typeof loginResultSchema>;

export const verifyCodeRequestSchema = z.object({
  code: z
    .string()
    .trim()
    .regex(/^\d{4,10}$/, 'Код состоит из цифр'),
});
export type VerifyCodeRequest = z.infer<typeof verifyCodeRequestSchema>;

export const loginVerificationSchema = z.object({
  enabled: z.boolean(),
  changeable: z.boolean(),
});
export type LoginVerification = z.infer<typeof loginVerificationSchema>;

export const updateLoginVerificationSchema = z.object({
  enabled: z.boolean(),
  password: z.string().min(1, 'Введите текущий пароль').max(256),
});
export type UpdateLoginVerification = z.infer<typeof updateLoginVerificationSchema>;
